import React from "react";
import { Link } from "react-router-dom";

const ModernSlaveryStatement = () => {
  const statements = [
    { year: 2024, to: "/policies/modern-slavery-statement/2024" },
    { year: 2023, to: "/policies/modern-slavery-statement/2023" },
    { year: 2022, to: "/policies/modern-slavery-statement/2022" },
    { year: 2021, to: "/policies/modern-slavery-statement/2021" },
  ];

  return (
    <section className="w-full bg-primary text-white relative">
      <div className="max-w-5xl mx-auto px-4 py-16 md:pt-40 flex flex-col md:flex-row items-center">
        <h1 className="text-brandAccent text-4xl md:text-5xl font-extrabold mb-4">
          Modern slavery statement
        </h1>
      </div>

      <div className="bg-white rounded-t-3xl flex flex-col gap-12 pt-20 pb-40 px-6 md:px-32">
        {statements.map(({ year, to }) => (
          <Link
            key={year}
            to={to}
            className="underline text-primary text-lg font-medium hover:text-primary-dark"
          >
            Modern slavery statement {year}
          </Link>
        ))}
      </div>
    </section>
  );
};

export default ModernSlaveryStatement;
